import Date from '../../date/Date';

export default class Announcement {
    static fromData(data) {
        if (!data) {
            return;
        }

        const announcement = new Announcement();
        announcement.id = data.id;
        announcement.start = data.start ? Date.fromIso8601(data.start) : null;
        announcement.end = data.end ? Date.fromIso8601(data.end) : null;
        announcement.applicationNumber = data.applicationNumber;
        announcement.childNumber = data.childNumber;
        announcement.child = data.child;
        announcement.processLog = data.processLog ?? null;

        return announcement;
    }
}
